import { useState, useEffect } from 'react';
import API from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { toast } from 'sonner';

export default function Bitacora() {
  const [movements, setMovements] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [warehouseId, setWarehouseId] = useState('');
  const [moveType, setMoveType] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    API.get('/catalogs/warehouses').then(res => setWarehouses(res.data));
  }, []);

  useEffect(() => {
    const params = { limit: 200 };
    if (warehouseId && warehouseId !== 'all') params.warehouse_id = warehouseId;
    if (moveType && moveType !== 'all') params.movement_type = moveType;
    setLoading(true);
    API.get('/inventario/movimientos', { params })
      .then(res => setMovements(res.data))
      .catch(() => toast.error('Error'))
      .finally(() => setLoading(false));
  }, [warehouseId, moveType]);

  const MOVE_LABELS = {
    entrada_usados: 'Entrada Usados',
    clasificacion_a_gallos: 'Clasif. a Gallos',
    clasificacion_a_cascos: 'Clasif. a Cascos',
    clasificacion_a_merma: 'Clasif. a Merma',
    salida_revision: 'Salida Revisión',
    regreso_revision: 'Regreso Revisión',
    agregar_a_tarima: 'Agregar a Tarima',
    mover_tarima_bodega: 'Mover a Bodega',
    salida_camion: 'Salida Camión',
    ajuste_inventario: 'Ajuste'
  };

  const MOVE_TYPES = Object.keys(MOVE_LABELS);

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-semibold">Bitácora de Movimientos</h1>
        <p className="text-sm text-muted-foreground">Historial completo de movimientos de inventario</p>
      </div>

      <Card className="bg-white border">
        <CardContent className="p-4">
          <div className="flex flex-wrap gap-3">
            <Select value={warehouseId} onValueChange={setWarehouseId}>
              <SelectTrigger className="w-[200px]"><SelectValue placeholder="Todos los almacenes" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Todos</SelectItem>
                {warehouses.map(w => <SelectItem key={w.id} value={w.id}>{w.nombre}</SelectItem>)}
              </SelectContent>
            </Select>
            <Select value={moveType} onValueChange={setMoveType}>
              <SelectTrigger className="w-[200px]"><SelectValue placeholder="Todos los tipos" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Todos</SelectItem>
                {MOVE_TYPES.map(t => <SelectItem key={t} value={t}>{MOVE_LABELS[t]}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-white border"><CardContent className="p-0">
        <Table>
          <TableHeader><TableRow className="bg-muted/30">
            <TableHead>Fecha</TableHead>
            <TableHead>Tipo</TableHead>
            <TableHead>Grupo</TableHead>
            <TableHead className="text-right">Cantidad</TableHead>
            <TableHead>Origen</TableHead>
            <TableHead>Destino</TableHead>
            <TableHead>Observaciones</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {loading && <TableRow><TableCell colSpan={7} className="text-center py-8">Cargando...</TableCell></TableRow>}
            {!loading && movements.length === 0 && <TableRow><TableCell colSpan={7} className="text-center text-muted-foreground py-8">Sin movimientos</TableCell></TableRow>}
            {!loading && movements.map((m, i) => (
              <TableRow key={i} className="hover:bg-muted/40">
                <TableCell className="text-xs">{new Date(m.fecha).toLocaleString('es-MX')}</TableCell>
                <TableCell className="text-xs">
                  <span className="px-2 py-0.5 rounded bg-muted text-foreground">{MOVE_LABELS[m.movement_type] || m.movement_type}</span>
                </TableCell>
                <TableCell className="font-medium">{m.group_code}</TableCell>
                <TableCell className="text-right font-semibold">{m.cantidad}</TableCell>
                <TableCell className="text-xs capitalize text-muted-foreground">{m.inventory_type_origin || '-'}</TableCell>
                <TableCell className="text-xs capitalize text-muted-foreground">{m.inventory_type_destiny || '-'}</TableCell>
                <TableCell className="text-xs text-muted-foreground max-w-[200px] truncate">{m.observaciones || '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent></Card>
    </div>
  );
}
